import React, { Component } from 'react';

import { Dialog } from '../../base/dialog';

export default class VoteDialog extends Component {

    saveData(value,id) {
        window.savevote(value,id);
        document.getElementById('modal-dialog-cancel-button').click()
        }

    render() {
        const poll=window.getvote();

        if(!poll.voteid) {
                return (
                    <Dialog
                        submitDisabled = { true }
                        cancelKey = { 'dialog.close' }
                        titleKey =  'Votazione'
                        width = 'small'>
                        <h1 style={styles.title}> Nessuna votazione attiva </h1>
                    </Dialog>

                );
            }

        const items = [];
        var buttonstyle;

        for (const [index, value] of poll.elements.entries()) {
          if (value == 'Favorevole') buttonstyle = styles.favorevole;
          else if (value == 'Contrario') buttonstyle = styles.contrario;  
          else if (value == 'Astenuto') buttonstyle = styles.astenuto;  
          else buttonstyle = styles.altro;  
          items.push(<input type="button" value={value} id={value} onClick={this.saveData.bind(this, value,poll.voteid)} style={buttonstyle}/>)
          items.push(<span>&nbsp;</span>)
          }

        return (
            <Dialog
                submitDisabled = { true }
                cancelKey = { 'dialog.close' }
                titleKey =  'Votazione'
                width = 'small'>
                <h1 style={styles.title}> {poll.subject} </h1>
                <div>&nbsp;</div>
                <div>
                    {items}
               </div>
            </Dialog>

        );
    }
}
    const styles = {
         favorevole: {
            background: 'green',
            fontSize: '1.5em',
            borderStyle: 'outset',
             },
         contrario: {
            background: 'red',
            fontSize: '1.5em',
            borderStyle: 'outset',
             },
         astenuto: {
            background: 'yellow',
            fontSize: '1.5em',
            borderStyle: 'outset',
             },
         altro: {
            background: 'white',
            fontSize: '1.5em',
            borderStyle: 'outset',
             },
         title: {
            color: 'white',
            }
        };


